import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { environment } from '@environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DeviceIdService } from '@services/device-id.service';
import { provideNgxWebstorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { providePrimeNG } from 'primeng/config';
import { tucuatePreset } from '../presets/tucuate-preset';
import { routes } from './app.routing';
import { graphqlProviders } from './graphql.providers';
import { deviceIdInterceptor } from './interceptors/device-id.interceptor';

// El JSON no lleva hash y el navegador lo cachea 1 hora: se versiona la URL con la versión de package.json (hay que subirla al desplegar).
export const TRANSLATIONS_SUFFIX = `.json?v=${environment.appVersion}`;

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', TRANSLATIONS_SUFFIX);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(withFetch(), withInterceptors([deviceIdInterceptor])),
    provideAppInitializer(() => {
      inject(DeviceIdService).getOrCreate();
    }),
    provideAnimations(),
    provideClientHydration(),
    providePrimeNG({
      theme: {
        preset: tucuatePreset,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
    ...graphqlProviders,
    ApmService,
    provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'tucuate', separator: '.', caseSensitive: true }), withSessionStorage()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
    importProvidersFrom(AngularFireModule.initializeApp(environment.firebase), AngularFireAuthModule, AngularFireMessagingModule, ApmModule),
  ],
};
